import { render, staticRenderFns } from "./LivingWithMigraines.vue?vue&type=template&id=78cdfc96&scoped=true&"
import script from "./LivingWithMigraines.vue?vue&type=script&lang=js&"
export * from "./LivingWithMigraines.vue?vue&type=script&lang=js&"
import style0 from "./LivingWithMigraines.vue?vue&type=style&index=0&id=78cdfc96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cdfc96",
  null
  
)

export default component.exports